<app-chart-download-button (buttonClick)="downloadTable()">
  <h3 class="title" translate>sprint9.cockpit.card.all.tabelle</h3>
</app-chart-download-button>

<div class="table-wrapper">
  @if (data) {
    <table>
      <tr>
        <td class="no-border"><br></td>
        @for (kategorie of kategorien; track kategorie) {
          <th scope="col" class="header centered bold border-bold-left border-bold-right" rowspan="2"
            >
            {{kategorie}}
          </th>
        }
      </tr>
      <tr>
        <th scope="col" class="header border-bold-left border-bold-right"><br></th>
      </tr>
      <tr>
        <th scope="col" class="border-bold-left border-bold-right">{{columnTxtKey | translate}}</th>
        @for (kategorie of kategorien; track kategorie) {
          <td class="text-align-right border-bold-right">
            {{ kategorie | retrievevalueByIndex: data }}
          </td>
        }
      </tr>
      <tr>
        <td class="hint" [attr.colspan]="kategorien.length+1">{{tableBottomTxtKey | translate}}</td>
      </tr>
    </table>
  }
</div>
